import {basePath} from './global';

$('main.profil-commune .referent-plus').on('click', function () {

    let count = $('.ref-wrap').length + 1;

    let input = '<div class="ref-wrap">\n' +
        '\n' +
        '    <div class="contact-title">\n' +
        '        <h3>Contact numéro ' + count + '</h3>\n' +
        '        <p>Référent pour l’organisation de Chemin des artistes <br>\n' +
        '            (informations transmises uniquement à Valence Romans Agglo)</p>\n' +
        '    </div>\n' +
        '\n' +
        '    <div class="form-split d-flex justify-content-between align-items-center">\n' +
        '\n' +
        '\n' +
        '\n' +
        '        <div class="input-wrapper mx-2">\n' +
        '            <input type="text" name="first_name[]" value="" class="custom-input" placeholder="Prénom du référent">\n' +
        '            <div class="pencil">\n' +
        '                <img src="http://localhost/chemindesartistes/assets/img/profilcommune/pencil-black.svg" alt="Icone stylo">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="input-wrapper mx-2">\n' +
        '            <input type="text" name="last_name[]" value="" class="custom-input" placeholder="Nom du référent">\n' +
        '            <div class="pencil">\n' +
        '                <img src="http://localhost/chemindesartistes/assets/img/profilcommune/pencil-black.svg" alt="Icone stylo">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="input-wrapper mx-2">\n' +
        '            <input type="text" name="email_ref[]" value="" class="custom-input" placeholder="Email du référent">\n' +
        '            <div class="pencil">\n' +
        '                <img src="http://localhost/chemindesartistes/assets/img/profilcommune/pencil-black.svg" alt="Icone stylo">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '\n' +
        '    <div class="form-split d-flex justify-content-between align-items-center">\n' +
        '        <div class="input-wrapper mx-2">\n' +
        '            <input type="text" name="fonction_ref[]" value="" class="custom-input" placeholder="Fonction du référent">\n' +
        '            <div class="pencil">\n' +
        '                <img src="http://localhost/chemindesartistes/assets/img/profilcommune/pencil-black.svg" alt="Icone stylo">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="input-wrapper mx-2">\n' +
        '            <input type="text" name="land_phone_ref[]" value="" class="custom-input" placeholder="Tél. fixe du référent">\n' +
        '            <div class="pencil">\n' +
        '                <img src="http://localhost/chemindesartistes/assets/img/profilcommune/pencil-black.svg" alt="Icone stylo">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="input-wrapper mx-2">\n' +
        '            <input type="text" name="mobile_phone_ref[]" value="" class="custom-input" placeholder="Tél. mobile du référent">\n' +
        '            <div class="pencil">\n' +
        '                <img src="http://localhost/chemindesartistes/assets/img/profilcommune/pencil-black.svg" alt="Icone stylo">\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '\n' +
        '    <div class="d-flex align-items-center">\n' +
        '        <p class="mr-2 mb-0">Supprimer ce référent : </p>\n' +
        '        <i class="icon-minus referent-minus"></i>\n' +
        '    </div>\n' +
        '\n' +
        '    <hr>\n' +
        '</div>'

    $('#referent-input-wrap').append(input);
})


$('body').on('click', 'main.profil-commune .referent-minus', function (e) {
    //On supprime les input de referent et on les supprime en BDD si besoin
    let parent = $(this).closest('.ref-wrap')
    let parentId = parent.attr('data-id');
    if (parentId === undefined) {
        parent.remove();
    } else if ($('#referent-input-wrap').children().length === 1) {
        e.preventDefault();
    } else {
        $.ajax({
            url: base_url + 'ajax/commune-delete-referent/',
            method: 'POST',
            global: false,
            data: {id: parentId},
            dataType: "json",
            success: function (data) {
                parent.remove();
            }
        })
    }
})


// WEBPACK FOOTER //
// ./src/js/app/profil-commune.js